import SectionReveal from "@/components/SectionReveal";
import { Cloud, Laptop, MapPin, Network, Server, ShieldCheck } from "lucide-react";

const surfaces = [
  { label: "Cloud", detail: "Public and private environments", icon: Cloud },
  { label: "Edge", detail: "Close to demanding workloads", icon: Network },
  { label: "Branch", detail: "Distributed sites and services", icon: MapPin },
  { label: "On-premise", detail: "Customer-controlled infrastructure", icon: Server },
  { label: "Sovereign", detail: "Defined control and locality", icon: ShieldCheck },
  { label: "Endpoint", detail: "People and connected devices", icon: Laptop },
];

export default function DeploymentTopology() {
  return (
    <SectionReveal as="figure" className="lf-deployment-topology lf-signal-diagram">
      <figcaption>One managed topology across every supported surface</figcaption>
      <div className="lf-topology-hub">
        <span>LightningFlow</span>
        <strong>Command Centre</strong>
        <small>Policy · health · topology · intelligence</small>
      </div>
      <ol>
        {surfaces.map(({ label, detail, icon: Icon }, index) => (
          <li key={label}>
            <span className="lf-topology-index">0{index + 1}</span>
            <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" />
            <strong>{label}</strong>
            <small>{detail}</small>
          </li>
        ))}
      </ol>
    </SectionReveal>
  );
}
